import { Box } from "ui/box/box";
import { Tooltip } from "ui/tooltip/tooltip";
import {
  FIELD_LABEL_GENERATION_ICON_SX,
  FIELD_LABEL_ROW_SX,
  FIELD_LABEL_SIZE_SX,
  FieldLabelRoot,
} from "ui/forms/field-label/field-label.styles";
import { type FieldLabelProps } from "ui/forms/field-label/field-label.types";
import { mergeSx } from "ui/merge-sx";

import Icons from "assets";

export const FieldLabel = ({
  name,
  id,
  disabled,
  required,
  infoTooltip,
  size = "medium",
  sx,
  children,
  ...rest
}: FieldLabelProps) => (
  <Box sx={FIELD_LABEL_ROW_SX}>
    <FieldLabelRoot
      {...rest}
      htmlFor={name}
      id={name ? `${name}-label` : id}
      disabled={disabled}
      required={!disabled && required}
      sx={mergeSx(FIELD_LABEL_SIZE_SX[size], sx)}>
      {children}
    </FieldLabelRoot>
    {infoTooltip && (
      <Tooltip label={infoTooltip} placement="bottom">
        <Box component="span" sx={FIELD_LABEL_GENERATION_ICON_SX}>
          <Icons.InfoIndicator width={16} height={16} />
        </Box>
      </Tooltip>
    )}
  </Box>
);
